module.exports = __webpack_public_path__ + "img/lx.0c6c0077.png";